import KunLoading77 from './src/index'

KunLoading77.install = function (Vue) {
	Vue.component(KunLoading77.name, KunLoading77);
}

export default KunLoading77;
